import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/simp_at/step3';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { TypeNatureMarcheChoix } from '../models/TypeNatureMarcheChoix';
@Component({
	selector: 'app-type-nature-marche-choix',
	templateUrl: './type-nature-marche-choix.component.html'
})
export class TypeNatureMarcheChoixComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeNatureMarcheChoix';
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() natureMarche: TypeNatureMarcheChoix;

	public step3 = new Step3();

	public readonly travauxValue = RadioCheckBoxEnum.travauxValue;
	public readonly fournituresValue = RadioCheckBoxEnum.fournituresValue;
	public readonly servicesValue = RadioCheckBoxEnum.servicesValue;

	public radioButtonValue: string;
	public radioButtonCtrlName: string;

	constructor() {}

	public ngOnInit() {
		if (this.natureMarche.fournitures === RadioCheckBoxEnum.emptyValue) {
			this.radioButtonValue = this.fournituresValue;
		} else if (this.natureMarche.services === RadioCheckBoxEnum.emptyValue) {
			this.radioButtonValue = this.servicesValue;
		} else {
			this.radioButtonValue = this.travauxValue;
		}
		this.radioButtonCtrlName = this.getUid() + '_SepAtt_travaux';
	}

	public getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
